import Utils from "@cirrus/legacy/app-common/utils/utils.es6"
import i18n from "@cirrus/legacy/app-common/alt/framework/i18n.js"
var getMoment = Utils.getMoment
var getMomentByDateTimeZone = Utils.getMomentByDateTimeZone

let momentFormats = {
  short: "L LT",
  long: "LLL",
  onlyDate: "L",
}

export function dateChangeFormat(changeDate, changedBy) {
  return i18n("General:ModifiedOnBy")
    .replace("{0}", Utils.dtDayMonthYearShortTime(changeDate))
    .replace("{1}", changedBy)
}

export default (date, format) => {
  let momentFormat = momentFormats[format]

  return momentFormat ? getMoment(date).format(momentFormat) : date
}

export function formatRelative(date) {
  const dtNow = getMoment().utc()
  const momentNow = getMoment(dtNow)
  return getMoment(date).from(momentNow)
}

export const formatDateByTimeZone = (date, format) => {
  let momentFormat = momentFormats[format]

  var dateWithTimeZone = getMomentByDateTimeZone(date)

  return momentFormat ? dateWithTimeZone.format(momentFormat) : dateWithTimeZone
}
